import { render } from "./MetricCard.vue?vue&type=template&id=410affa6&scoped=true"
import script from "./MetricCard.vue?vue&type=script&lang=js"
export * from "./MetricCard.vue?vue&type=script&lang=js"

import "./MetricCard.vue?vue&type=style&index=0&id=410affa6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-410affa6"]])

export default __exports__